import React from "react";
import { useSelector } from "react-redux";

import { SelectField } from "components/Form/FormikControls";

import { getExportSitesByDeploymentId, toExportSiteOption } from "selectors";

interface ExportSitesFieldProps {
  name: string;
  label: string;
  deploymentId?: number | null;
  disabled?: boolean;
}

export function ExportSitesField(
  props: ExportSitesFieldProps,
): React.JSX.Element {
  const { name, label, deploymentId, disabled = false } = props;
  const exportSites = useSelector(getExportSitesByDeploymentId(deploymentId)) as
    | string[]
    | undefined;
  const options = (exportSites || []).map(toExportSiteOption);

  return (
    <SelectField
      isMulti
      options={options}
      name={name}
      label={label}
      disabled={disabled}
    />
  );
}
